import { ActionMenu, ActionMenuItem } from '@systemeio/ui'
import React, { FC, useState } from 'react'
import ConfirmationModal from 'shared/components/confirmation-modal'
import { useLocoTranslation } from 'shared/hooks/use-loco-translation'
import { AddHeaderModal } from '../content/header/add-header'

interface Props {
  title: string
  id: number
  onDelete: () => Promise<void>
}

const HeaderItemContent: FC<Props> = ({ title, id, onDelete }) => {
  const { t } = useLocoTranslation()

  const [deleteOpened, setDeleteOpened] = useState(false)
  const [editOpened, setEditOpened] = useState(false)

  return (
    <div className={'flex w-full cursor-pointer items-center gap-5 border-transparent p-5'}>
      <div className={'flex flex-col items-start gap-1'}>
        <b className={'text-text-primary text-[24px]'}>{title}</b>
      </div>
      <div className={'ml-auto'}>
        <ActionMenu
          menuItems={[
            <ActionMenuItem
              key={'action-edit'}
              onClick={() => {
                setEditOpened(true)
              }}
              label={t('global.edit')}
            />,
            <ActionMenuItem
              key={'action-delete'}
              onClick={() => {
                setDeleteOpened(true)
              }}
              label={t('global.delete')}
            />,
          ]}
        />
        <ConfirmationModal
          confirmationText={t('dashboard.store.item.delete_confirmation')}
          toastCaption={t('dashboard.store.item.delete_success')}
          opened={deleteOpened}
          onClose={() => setDeleteOpened(false)}
          onConfirm={onDelete}
        />

        <AddHeaderModal id={id} initialText={title} opened={editOpened} setOpened={setEditOpened} />
      </div>
    </div>
  )
}

export default HeaderItemContent
